import React from 'react'
import PropTypes from 'prop-types'
import {Content} from '@builder.io/sdk-react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {cn} from '@/lib/utils'
import {customComponents} from 'hec/builder'
import {Button, routeTypes} from '@/components/ui/button'
import {Collapsible, CollapsibleTrigger, CollapsibleContent} from '@/components/ui/collapsible'
import ChevronDown from 'hec/assets/icons/chevron-down'

const Brand = ({content, isOpen, onToggle}) => {
    const config = getConfig()

    return (
        <Collapsible open={isOpen} onOpenChange={onToggle} data-testid="brand-Collapsible">
            <CollapsibleTrigger
                className="w-full [&[data-state=closed]_svg]:-rotate-90"
                data-testid="brand-CollapsibleTrigger"
            >
                <Button
                    className={cn(
                        'text-blue-05 flex justify-between items-center pt-[0.625rem] pr-[0.5rem] pb-[0.4375rem] pl-[1.25rem] hover:[text-shadow:_0_0_0.0625rem_#132744] focus:[text-shadow:_0_0_0.0625rem_#132744]',
                        isOpen && '[text-shadow:_0_0_0.0625rem_#132744]'
                    )}
                    ctaType="link"
                    routeType={routeTypes.EXTERNAL}
                    hrefValue={null}
                    asChild
                    data-testid="brand-Button"
                >
                    Brand <ChevronDown className="w-3 h-[0.4375rem]" />
                </Button>
            </CollapsibleTrigger>
            <CollapsibleContent className="px-[0.9375rem]" data-testid="brand-CollapsibleContent">
                <Content
                    model="symbol"
                    content={content}
                    apiKey={config.app.builder.api}
                    customComponents={customComponents}
                    data-testid="brand-Content"
                />
            </CollapsibleContent>
        </Collapsible>
    )
}

Brand.propTypes = {
    content: PropTypes.object.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired
}

export default Brand
